import {
    chatProjection,
    createSceneProjection,
    localPlayerProjection,
    playerProjection,
    useGameStore,
    usePixiRenderOnStoreChange,
} from '@glark-newco/game-library';
import {useEffect} from 'react';
import {avatarProjection} from './signlinesAvatarSlice';
import {boardProjection} from './signlinesBoardSlice';
import {planningAccuracyProjection} from './signlinesPlanningAccuracySlice';
import {playerStatsProjection} from './signlinesPlayerStatsSlice';
import {timestampsProjection} from './signlinesTimestampsSlice';
import {useUIStore} from './useSignlinesUIStore';
import {SignLinesSceneMutator} from '../components/SignLinesSceneMutator';

export const SignlinesProjections = () => {
    const register = useGameStore(state => state.registerProjection);
    const reset = useGameStore(state => state.reset);
    usePixiRenderOnStoreChange(useUIStore);

    useEffect(() => {
        register(playerProjection);
        register(localPlayerProjection);
        register(chatProjection);
        register(createSceneProjection(SignLinesSceneMutator));

        register(avatarProjection);
        register(boardProjection);
        register(playerStatsProjection);
        register(timestampsProjection);
        register(planningAccuracyProjection);

        return () => reset();
    }, [register, reset]);

    return null;
};
